import { takeLatest, call, put, all } from 'redux-saga/effects';
import validarCPF from '../../../../util/validarCpf';
import history from '../../../../services/history';
import api from '../../../../services/api';
import { signInSuccess, signFailure } from './actions';

function mensagemLogin(error, fallback) {
  return (
    error?.response?.data?.message || error?.response?.data?.error || fallback
  );
}

export function* signIn({ payload }) {
  try {
    const { cpf, senha } = payload;

    if (!validarCPF(cpf)) {
      yield put(signFailure('CPF inválido.'));
      return;
    }

    const response = yield call(api.post, 'fsessions', { cpf, senha });

    const { token, funcionario } = response.data;

    api.defaults.headers.Authorization = `Bearer ${token}`;
    yield put(signInSuccess(token, funcionario));
    history.push('/agenda');
  } catch (error) {
    yield put(signFailure(mensagemLogin(error, 'Erro ao fazer login!')));
  }
}

export function setToken({ payload }) {
  if (!payload) return;
  const { token } = payload.funcionario;
  if (token) api.defaults.headers.Authorization = `Bearer ${token}`;
}

export function signOut() {
  history.push('/');
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest('@funcionario/SIGN_IN_REQUEST', signIn),
  takeLatest('@funcionario/SIGN_OUT', signOut),
]);
